import { render } from "./SalesRank.vue?vue&type=template&id=a9f113a8&scoped=true"
import script from "./SalesRank.vue?vue&type=script&lang=js"
export * from "./SalesRank.vue?vue&type=script&lang=js"

import "./SalesRank.vue?vue&type=style&index=0&id=a9f113a8&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9f113a8"]])

export default __exports__